/**
 * ch_util
 *
 * "A big mess of globals and polyfills"
 */
define('ch_utils',[],function () {
    String.prototype.toCamel = function () {
        return this.replace(/(\-[a-z])/g, function ($1) { return $1.toUpperCase().replace('-', ''); });
    };

    String.prototype.toDash = function () {
        return this.replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); });
    };

    String.prototype.toUnderscore = function () {
        return this.replace(/([A-Z])/g, function ($1) { return '_' + $1.toLowerCase(); });
    };

    String.prototype.toHuman = function () {
        return this.replace(/[_\]\[]/g, ' ').trim().replace(/(?:^|\s)\w/g, function (match) {
            return match.toUpperCase();
        });
    };

    String.prototype.upperCaseFirstChar = function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };

    window.preg_quote = function (str, delimiter) {
        return String(str).replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&');
    };

    // Generates prices in right format
    window.formatPrice = function (value) {
        return '$' + parseFloat(value).toFixed(2);
    };

    window.pluralize = function (singular, plural, count) {
        return count == 1 ? singular : plural;
    };

    // Text-Area character counter
    window.characterCounter = function (formElement, maxCount, charactersRemainingElement) {
        var charsLength = $(formElement).val().length;
        var charsRemaining = maxCount - charsLength;
        var remainingString = ' characters remaining.';
        if (charsRemaining == 1) {
            remainingString = ' character remaining... make it count!';
        }
        var str = charsRemaining >= 0 ? charsRemaining + remainingString : 'Your message is too long!';

        charactersRemainingElement.html(str);
    };

    /**
     * numberFormat
     *
     * Formats a number with commas similar to PHP's number_format function
     *
     * @param   numStr      a number or numeric string
     * @returns string      number with commas
     */
    window.numberFormat = function (numStr) {
        var x; var x1; var x2; var
            rgx;

        // convert to string
        numStr += '';

        x = numStr.split('.');
        x1 = x[0];
        x2 = x.length > 1 ? '.' + x[1] : '';
        rgx = /(\d+)(\d{3})/;

        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }

        return x1 + x2;
    };

    /**
     * updateQueryStringParameter
     *
     * add or update the value of a URL query string parameter
     *
     * @source  http://stackoverflow.com/questions/5999118/add-or-update-query-string-parameter
     * @param   string  uri     the uri string
     * @param   string  key     the parameter to affect
     * @param   mixed   value   the value to set
     * @returns string          the uri string with query parameter set
     */
    window.updateQueryStringParameter = function (uri, key, value) {
        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        var separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + '=' + value + '$2');
        }
        return uri + separator + key + '=' + value;
    };

    /**
     * convertCbGroupsToStrings
     *
     * copy the value of a checkbbox group inputs over to a comma-delimited string in an input
     *
     * for example, copy the value in "day[]" (saturday and sunday are checked)
     * to the matching input with a name "day" and the value "saturday,sunday"
     *
     * auto-creates the input value if it is not present
     *
     * @param array cbGroups      array of checkbox group selectors for jquery
     */
    // @TODO: Move/refactor to ch_simple_filters.js once that's the canonical filtering module
    window.convertCbGroupsToStrings = function (cbGroups, $form) {
        $.each(cbGroups, function (i, selector) {
            // get all inputs of that selection
            var $selectedInputs = $(selector, $form);
            var valueString;
            var newInputName;
            var $stringInput;

            if ($selectedInputs) {
                // map values of checked inputs into comma-delim string
                valueString = $selectedInputs.filter(':checked').map(function () {
                    return this.value;
                }).get().join(',');

                // find the previous or prepare a new input field
                // for storing and submitting the comma-delim string
                newInputName = $selectedInputs
                    .first()
                    .attr('name');

                // if we have a value and name to work with
                if (newInputName) {
                    $stringInput = $('input[name=' + newInputName.replace(/\[\]/g, '') + ']');

                    if (!$stringInput.length) {
                        $stringInput = $('<input type="hidden">')
                            .attr('name', newInputName.replace(/\[\]/g, ''))
                            .appendTo($form);
                    }

                    $stringInput.val(valueString);
                }
            }
        });
    };

    /**
     * parseURI 1.2.2
     *
     * Parse a URI string into an object of URI properties.
     *
     * (c) Steven Levithan <stevenlevithan.com>
     * MIT License
     *
     * @param str
     * @returns {{}}
     */
    window.parseUri = function (str) {
        var o = parseUri.options;
        var m = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str);
        var uri = {};
        var i = 14;

        while (i--) uri[o.key[i]] = m[i] || '';

        uri[o.q.name] = {};
        uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
            if ($1) uri[o.q.name][$1] = $2;
        });

        return uri;
    };

    parseUri.options = {
        strictMode: false,
        key: [
            'source',
            'protocol',
            'authority',
            'userInfo',
            'user',
            'password',
            'host',
            'port',
            'relative',
            'path',
            'directory',
            'file',
            'query',
            'anchor',
        ],
        q: {
            name: 'queryKey',
            parser: /(?:^|&)([^&=]*)=?([^&]*)/g,
        },
        parser: {
            strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
            loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
        },
    };
});

